import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "motion/react";
import { LoginUser } from "../../Services/Operations/ProductAPI";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCredentials } from "../../Store/authSlice";
import { toast } from "react-toastify";

const GOLD = "#e5932e";
const TAN = "#bba58b";
const WHITE = "#ffffff";

const tools = ["📐", "🪚", "🔨", "🪛", "🏠", "🪟", "🚪", "🪜"];

function FloatingIcon({ icon, x, y, delay, size }) {
  return (
    <motion.div
      style={{
        position: "absolute",
        left: `${x}%`,
        top: `${y}%`,
        fontSize: size,
        opacity: 0,
        pointerEvents: "none",
        zIndex: 0,
        filter: "blur(0.5px)",
      }}
      animate={{
        opacity: [0, 0.18, 0],
        y: [0, -30, -60],
        rotate: [0, 15, -10],
      }}
      transition={{
        duration: 6,
        delay,
        repeat: Infinity,
        repeatDelay: Math.random() * 4 + 2,
        ease: "easeInOut",
      }}
    >
      {icon}
    </motion.div>
  );
}

const Login = () => {
    const dispatch=useDispatch()
    const navigate=useNavigate()
 const [email, setEmail] = useState("");
   const [password, setPassword] = useState("");
   const [showPass, setShowPass] = useState(false);
   const [focused, setFocused] = useState(null);
   const [submitted, setSubmitted] = useState(false);
   const [loading, setLoading] = useState(false);
   const [floaters] = useState(() =>
     Array.from({ length: 12 }, (_, i) => ({
       icon: tools[i % tools.length],
       x: Math.random() * 90 + 5,
       y: Math.random() * 80 + 10,
       delay: i * 0.7,
       size: `${Math.random() * 14 + 14}px`,
     }))
   );
 
   const handleSubmit = async() => {
     if (!email || !password) return;
     setLoading(true);
     try {
        const res= await LoginUser({email,password})
        console.log(res);
        if(res.status===200){
           setLoading(false);
       setSubmitted(true);  
       dispatch(setCredentials({user:res.data.data,token:res.data.token}))
       toast.success("Loggedin successfully")
        setTimeout(() => {
       navigate("/")
     }, 1800);
        }
        
     } catch (error) {
        console.log(error);
         setLoading(false);
    toast.error("Wrong Credentials")
     }
    
   };
 
   return (
     <div
       style={{
         minHeight: "100vh",
         width: "100%",
         fontFamily: "'Cormorant Garamond', Georgia, serif",
         position: "relative",
         overflow: "hidden",
         display: "flex",
         alignItems: "center",
         justifyContent: "center",
         background: `
           radial-gradient(ellipse at 70% 30%, rgba(229,147,46,0.18) 0%, transparent 60%),
           radial-gradient(ellipse at 20% 80%, rgba(187,165,139,0.22) 0%, transparent 55%),
           linear-gradient(135deg, #1a1208 0%, #2d1f0e 35%, #1c1407 70%, #0e0b05 100%)
         `,
       }}
     >
       {/* Google Font */}
       <style>{`
         @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&family=Josefin+Sans:wght@300;400;600&display=swap');
 
         * { box-sizing: border-box; margin: 0; padding: 0; }
 
         input:-webkit-autofill {
           -webkit-box-shadow: 0 0 0 100px rgba(187,165,139,0.08) inset !important;
           -webkit-text-fill-color: #fff !important;
         }
 
         .field-input::placeholder { color: rgba(187,165,139,0.45); }
 
         .login-btn:hover {
           background: linear-gradient(135deg, #f0a84a 0%, #e5932e 50%, #c97d22 100%) !important;
           transform: translateY(-2px) !important;
           box-shadow: 0 12px 40px rgba(229,147,46,0.5), 0 0 0 1px rgba(229,147,46,0.3) !important;
         }
         .login-btn:active { transform: translateY(0px) !important; }
         .login-btn:disabled { opacity: 0.7; cursor: not-allowed; }
 
         .social-btn:hover {
           background: rgba(187,165,139,0.15) !important;
           border-color: rgba(229,147,46,0.5) !important;
         }
       `}</style>
 
       {/* Animated background texture lines */}
       <svg
         style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0.06, pointerEvents: "none" }}
         xmlns="http://www.w3.org/2000/svg"
       >
         <defs>
           <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse">
             <path d="M 60 0 L 0 0 0 60" fill="none" stroke={TAN} strokeWidth="0.5" />
           </pattern>
         </defs>
         <rect width="100%" height="100%" fill="url(#grid)" />
       </svg>
 
       {/* Floating icons */}
       {floaters.map((f, i) => (
         <FloatingIcon key={i} {...f} />
       ))}
 
       {/* Diagonal accent bar */}
       <motion.div
         initial={{ scaleX: 0, opacity: 0 }}
         animate={{ scaleX: 1, opacity: 1 }}
         transition={{ duration: 1.2, ease: "easeOut", delay: 0.3 }}
         style={{
           position: "absolute",
           top: 0, right: 0,
           width: "38%", height: "100%",
           background: `linear-gradient(160deg, rgba(229,147,46,0.07) 0%, transparent 60%)`,
           borderLeft: `1px solid rgba(229,147,46,0.12)`,
           transformOrigin: "right center",
           pointerEvents: "none",
         }}
       />
 
       {/* Main card */}
       <AnimatePresence mode="wait">
         {!submitted ? (
           <motion.div
             key="form"
             initial={{ opacity: 0, y: 48, scale: 0.96 }}
             animate={{ opacity: 1, y: 0, scale: 1 }}
             exit={{ opacity: 0, y: -30, scale: 0.95 }}
             transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
             style={{
               position: "relative",
               zIndex: 10,
               width: "100%",
               maxWidth: 440,
               margin: "20px",
               background: `linear-gradient(145deg, rgba(255,255,255,0.06) 0%, rgba(187,165,139,0.06) 100%)`,
               backdropFilter: "blur(28px)",
               WebkitBackdropFilter: "blur(28px)",
               border: `1px solid rgba(187,165,139,0.22)`,
               borderRadius: 24,
               padding: "48px 44px 44px",
               boxShadow: `
                 0 40px 80px rgba(0,0,0,0.6),
                 0 0 0 1px rgba(229,147,46,0.1),
                 inset 0 1px 0 rgba(255,255,255,0.08),
                 0 8px 32px rgba(229,147,46,0.08)
               `,
             }}
           >
             {/* Top accent line */}
             <motion.div
               initial={{ scaleX: 0 }}
               animate={{ scaleX: 1 }}
               transition={{ duration: 0.9, delay: 0.5, ease: "easeOut" }}
               style={{
                 position: "absolute",
                 top: 0, left: "10%",
                 width: "80%", height: 2,
                 background: `linear-gradient(90deg, transparent, ${GOLD}, transparent)`,
                 borderRadius: 2,
                 transformOrigin: "center",
               }}
             />
          
             {/* Logo / Brand */}
             <motion.div
               initial={{ opacity: 0, y: -16 }}
               animate={{ opacity: 1, y: 0 }}
               transition={{ duration: 0.6, delay: 0.2 }}
               style={{ textAlign: "center", marginBottom: 36 }}
             >
               <div style={{
                 width: 64, height: 64,
                 borderRadius: 18,
                 background: `linear-gradient(135deg, ${GOLD} 0%, #c97d22 100%)`,
                 display: "flex", alignItems: "center", justifyContent: "center",
                 margin: "0 auto 16px",
                 boxShadow: `0 8px 24px rgba(229,147,46,0.4), inset 0 1px 0 rgba(255,255,255,0.2)`,
                 fontSize: 28,
               }}>
                 🏛️
               </div>
               <h1 style={{
                 fontFamily: "'Cormorant Garamond', serif",
                 fontSize: 28,
                 fontWeight: 600,
                 color: WHITE,
                 letterSpacing: "0.04em",
                 lineHeight: 1.1,
                 marginBottom: 6,
               }}>
                 Dhanushdhari Renovators
               </h1>
               <p style={{
                 fontFamily: "'Josefin Sans', sans-serif",
                 fontSize: 11,
                 fontWeight: 300,
                 color: TAN,
                 letterSpacing: "0.2em",
                 textTransform: "uppercase",
               }}>
                 Premium Renovation
               </p>
             </motion.div>
 
             {/* Heading */}
             <motion.div
               initial={{ opacity: 0, x: -16 }}
               animate={{ opacity: 1, x: 0 }}
               transition={{ duration: 0.5, delay: 0.35 }}
               style={{ marginBottom: 28 }}
             >
               <h2 style={{
                 fontFamily: "'Cormorant Garamond', serif",
                 fontSize: 20,
                 fontWeight: 400,
                 fontStyle: "italic",
                 color: `rgba(255,255,255,0.75)`,
                 letterSpacing: "0.02em",
               }}>
                 Welcome back
               </h2>
               <p style={{
                 fontFamily: "'Josefin Sans', sans-serif",
                 fontSize: 11,
                 color: `rgba(187,165,139,0.6)`,
                 letterSpacing: "0.12em",
                 textTransform: "uppercase",
                 marginTop: 4,
               }}>
                 Sign in to your workspace
               </p>
             </motion.div>
 
             {/* Email Field */}
             <motion.div
               initial={{ opacity: 0, y: 16 }}
               animate={{ opacity: 1, y: 0 }}
               transition={{ duration: 0.5, delay: 0.45 }}
               style={{ marginBottom: 16 }}
             >
               <label style={{
                 display: "block",
                 fontFamily: "'Josefin Sans', sans-serif",
                 fontSize: 10,
                 fontWeight: 600,
                 letterSpacing: "0.18em",
                 textTransform: "uppercase",
                 color: focused === "email" ? GOLD : TAN,
                 marginBottom: 8,
                 transition: "color 0.3s",
               }}>
                 Email Address
               </label>
               <div style={{ position: "relative" }}>
                 <span style={{
                   position: "absolute", left: 16, top: "50%",
                   transform: "translateY(-50%)",
                   fontSize: 16, opacity: 0.5,
                   pointerEvents: "none",
                 }}>✉️</span>
                 <input
                   className="field-input"
                   type="email"
                   value={email}
                   onChange={e => setEmail(e.target.value)}
                   onFocus={() => setFocused("email")}
                   onBlur={() => setFocused(null)}
                   placeholder="you@example.com"
                   style={{
                     width: "100%",
                     padding: "14px 16px 14px 44px",
                     background: focused === "email"
                       ? "rgba(229,147,46,0.08)"
                       : "rgba(187,165,139,0.07)",
                     border: `1px solid ${focused === "email" ? "rgba(229,147,46,0.5)" : "rgba(187,165,139,0.2)"}`,
                     borderRadius: 12,
                     color: WHITE,
                     fontSize: 15,
                     fontFamily: "'Josefin Sans', sans-serif",
                     fontWeight: 300,
                     outline: "none",
                     transition: "all 0.3s ease",
                     boxShadow: focused === "email" ? `0 0 0 3px rgba(229,147,46,0.12), 0 4px 16px rgba(229,147,46,0.08)` : "none",
                   }}
                 />
               </div>
             </motion.div>
 
             {/* Password Field */}
             <motion.div
               initial={{ opacity: 0, y: 16 }}
               animate={{ opacity: 1, y: 0 }}
               transition={{ duration: 0.5, delay: 0.55 }}
               style={{ marginBottom: 10 }}
             >
               <label style={{
                 display: "block",
                 fontFamily: "'Josefin Sans', sans-serif",
                 fontSize: 10,
                 fontWeight: 600,
                 letterSpacing: "0.18em",
                 textTransform: "uppercase",
                 color: focused === "pass" ? GOLD : TAN,
                 marginBottom: 8,
                 transition: "color 0.3s",
               }}>
                 Password
               </label>
               <div style={{ position: "relative" }}>
                 <span style={{
                   position: "absolute", left: 16, top: "50%",
                   transform: "translateY(-50%)",
                   fontSize: 16, opacity: 0.5,
                   pointerEvents: "none",
                 }}>🔒</span>
                 <input
                   className="field-input"
                   type={showPass ? "text" : "password"}
                   value={password}
                   onChange={e => setPassword(e.target.value)}
                   onFocus={() => setFocused("pass")}
                   onBlur={() => setFocused(null)}
                   placeholder="••••••••••"
                   style={{
                     width: "100%",
                     padding: "14px 48px 14px 44px",
                     background: focused === "pass"
                       ? "rgba(229,147,46,0.08)"
                       : "rgba(187,165,139,0.07)",
                     border: `1px solid ${focused === "pass" ? "rgba(229,147,46,0.5)" : "rgba(187,165,139,0.2)"}`,
                     borderRadius: 12,
                     color: WHITE,
                     fontSize: 15,
                     fontFamily: "'Josefin Sans', sans-serif",
                     fontWeight: 300,
                     outline: "none",
                     transition: "all 0.3s ease",
                     boxShadow: focused === "pass" ? `0 0 0 3px rgba(229,147,46,0.12), 0 4px 16px rgba(229,147,46,0.08)` : "none",
                   }}
                 />
                 <button
                   onClick={() => setShowPass(s => !s)}
                   style={{
                     position: "absolute", right: 14, top: "50%",
                     transform: "translateY(-50%)",
                     background: "none", border: "none",
                     cursor: "pointer", fontSize: 16,
                     opacity: 0.5, padding: 4,
                     transition: "opacity 0.2s",
                   }}
                   onMouseEnter={e => e.target.style.opacity = 1}
                   onMouseLeave={e => e.target.style.opacity = 0.5}
                 >
                   {showPass ? "🙈" : "👁️"}
                 </button>
               </div>
             </motion.div>
 
             {/* Forgot password */}
             <motion.div
               initial={{ opacity: 0 }}
               animate={{ opacity: 1 }}
               transition={{ delay: 0.6 }}
               style={{ textAlign: "right", marginBottom: 28 }}
             >
               <a href="#" style={{
                 fontFamily: "'Josefin Sans', sans-serif",
                 fontSize: 11,
                 color: TAN,
                 textDecoration: "none",
                 letterSpacing: "0.08em",
                 opacity: 0.75,
                 transition: "color 0.2s",
               }}
                 onMouseEnter={e => e.target.style.color = GOLD}
                 onMouseLeave={e => e.target.style.color = TAN}
               >
                 Forgot password?
               </a>
             </motion.div>
 
             {/* Submit Button */}
             <motion.div
               initial={{ opacity: 0, y: 12 }}
               animate={{ opacity: 1, y: 0 }}
               transition={{ duration: 0.5, delay: 0.65 }}
             >
               <button
                 className="login-btn"
                 onClick={handleSubmit}
                 disabled={loading}
                 style={{
                   width: "100%",
                   padding: "16px",
                   background: `linear-gradient(135deg, #f0a84a 0%, ${GOLD} 50%, #c97d22 100%)`,
                   border: "none",
                   borderRadius: 12,
                   color: "#1a0f02",
                   fontSize: 13,
                   fontFamily: "'Josefin Sans', sans-serif",
                   fontWeight: 600,
                   letterSpacing: "0.18em",
                   textTransform: "uppercase",
                   cursor: "pointer",
                   transition: "all 0.3s ease",
                   boxShadow: `0 8px 24px rgba(229,147,46,0.35), inset 0 1px 0 rgba(255,255,255,0.25)`,
                   display: "flex",
                   alignItems: "center",
                   justifyContent: "center",
                   gap: 10,
                 }}
               >
                 {loading ? (
                   <motion.span
                     animate={{ rotate: 360 }}
                     transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                     style={{ display: "inline-block", fontSize: 16 }}
                   >
                     ⚙️
                   </motion.span>
                 ) : (
                   <>
                     <span>Sign In</span>
                     <span style={{ fontSize: 14 }}>→</span>
                   </>
                 )}
               </button>
             </motion.div>
 
             {/* Divider */}
             <motion.div
               initial={{ opacity: 0 }}
               animate={{ opacity: 1 }}
               transition={{ delay: 0.72 }}
               style={{
                 display: "flex", alignItems: "center", gap: 12,
                 margin: "24px 0",
               }}
             >
               <div style={{ flex: 1, height: 1, background: "rgba(187,165,139,0.15)" }} />
               <span style={{
                 fontFamily: "'Josefin Sans', sans-serif",
                 fontSize: 10,
                 color: "rgba(187,165,139,0.4)",
                 letterSpacing: "0.12em",
                 textTransform: "uppercase",
               }}>or</span>
               <div style={{ flex: 1, height: 1, background: "rgba(187,165,139,0.15)" }} />
             </motion.div>
 
             {/* Social buttons */}
             <motion.div
               initial={{ opacity: 0, y: 10 }}
               animate={{ opacity: 1, y: 0 }}
               transition={{ delay: 0.78 }}
               style={{ display: "flex", gap: 10 }}
             >
               {[
                 { icon: "G", label: "Google" },
                 { icon: "in", label: "LinkedIn" },
               ].map(({ icon, label }) => (
                 <button
                   key={label}
                   className="social-btn"
                   style={{
                     flex: 1,
                     padding: "11px",
                     background: "rgba(187,165,139,0.07)",
                     border: `1px solid rgba(187,165,139,0.18)`,
                     borderRadius: 10,
                     color: "rgba(255,255,255,0.65)",
                     fontFamily: "'Josefin Sans', sans-serif",
                     fontSize: 12,
                     fontWeight: 600,
                     letterSpacing: "0.08em",
                     cursor: "pointer",
                     transition: "all 0.3s",
                     display: "flex",
                     alignItems: "center",
                     justifyContent: "center",
                     gap: 8,
                   }}
                 >
                   <span style={{
                     width: 20, height: 20,
                     borderRadius: 4,
                     background: "rgba(229,147,46,0.15)",
                     display: "flex", alignItems: "center", justifyContent: "center",
                     fontSize: 11, fontWeight: 700,
                     color: GOLD,
                   }}>{icon}</span>
                   {label}
                 </button>
               ))}
             </motion.div>
 
             {/* Sign up link */}
             <motion.p
               initial={{ opacity: 0 }}
               animate={{ opacity: 1 }}
               transition={{ delay: 0.85 }}
               style={{
                 textAlign: "center",
                 marginTop: 24,
                 fontFamily: "'Josefin Sans', sans-serif",
                 fontSize: 12,
                 color: "rgba(187,165,139,0.5)",
                 letterSpacing: "0.05em",
               }}
             >
               New to Renovators?{" "}
               <a href="/register" style={{
                 color: GOLD, textDecoration: "none",
                 fontWeight: 600, transition: "opacity 0.2s",
               }}
                 onMouseEnter={e => e.target.style.opacity = 0.75}
                 onMouseLeave={e => e.target.style.opacity = 1}
               >
                 Register
               </a>
             </motion.p>
           </motion.div>
         ) : (
           /* Success state */
           <motion.div
             key="success"
             initial={{ opacity: 0, scale: 0.85 }}
             animate={{ opacity: 1, scale: 1 }}
             transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
             style={{
               zIndex: 10,
               textAlign: "center",
               padding: 48,
               background: "rgba(255,255,255,0.05)",
               backdropFilter: "blur(28px)",
               border: `1px solid rgba(229,147,46,0.3)`,
               borderRadius: 24,
               boxShadow: `0 40px 80px rgba(0,0,0,0.5), 0 0 0 1px rgba(229,147,46,0.15)`,
               maxWidth: 360,
               margin: "20px",
             }}
           >
             <motion.div
               animate={{ scale: [1, 1.15, 1], rotate: [0, 10, -5, 0] }}
               transition={{ duration: 0.6, delay: 0.2 }}
               style={{ fontSize: 56, marginBottom: 20 }}
             >
               🏛️
             </motion.div>
             <h2 style={{
               fontFamily: "'Cormorant Garamond', serif",
               fontSize: 26, fontWeight: 600,
               color: WHITE, marginBottom: 8,
             }}>Welcome Back!</h2>
             <p style={{
               fontFamily: "'Josefin Sans', sans-serif",
               fontSize: 12, color: TAN,
               letterSpacing: "0.1em", textTransform: "uppercase",
             }}>Redirecting to your workspace…</p>
           </motion.div>
         )}
       </AnimatePresence>
 
       {/* Bottom brand mark */}
       <motion.div
         initial={{ opacity: 0 }}
         animate={{ opacity: 0.35 }}
         transition={{ delay: 1.2 }}
         style={{
           position: "absolute", bottom: 20, left: "50%",
           transform: "translateX(-50%)",
           fontFamily: "'Josefin Sans', sans-serif",
           fontSize: 10, color: TAN,
           letterSpacing: "0.2em",
           textTransform: "uppercase",
           whiteSpace: "nowrap",
           zIndex: 10,
         }}
       >
         © 2026 RenovaSpace · All Rights Reserved
       </motion.div>
     </div>
   );
}

export default Login
